<template>
  <div>
    <div id="external-payments-page" class="viewport viewport-with-top-nav viewport-compact" ref="viewportContainer">

      <TopNav></TopNav>

      <div class="display-1 my-3">{{ $t('ExternalPaymentsPage.title') }}</div>

      <p id="external-payments-page-description" v-if="hasMoreThanOnePaymentOption">{{ $t('ExternalPaymentsPage.description') }}</p>

      <div v-if="hasRecommended" id="recommended-repayment-channels">
        <h6 class="card-title mb-3" v-if="hasMoreThanOnePaymentOption">{{ $t('ExternalPaymentsPage.recommended') }}</h6>
        <div class="list-group list-group-escape-container mb-4">
          <router-link
            v-for="repaymentPartner of repaymentPartners.filter(x => x.recommended)"
            class="list-group-item list-group-item-action list-group-item-with-icon"
            :to="{ name: 'payment-redirect', params: { id: $route.params.id },  query: getQueryParams(repaymentPartner) }"
            v-bind:key="repaymentPartner.id"
          >
            <div>
              <div class="avatar mr-3" :style="'background-image: url(/img/payment/' + repaymentPartner.slug + '.png)'"></div>
            </div>
            <div class="flex-grow-1 mr-2">
              <strong>{{ repaymentPartner.title }}</strong>
              <div class="small text-muted">{{ $t(`PaymentPartners.description.${repaymentPartner.slug}`) }}</div>
            </div>
            <Icon icon-name="arrow-ios-forward-outline" icon-class="text-muted-more"></Icon>
          </router-link>
        </div>
      </div>

      <div v-if="hasOthers" id="other-repayment-channels">
        <h6 class="card-title mb-3" v-if="hasMoreThanOnePaymentOption">{{ $t('ExternalPaymentsPage.other') }}</h6>
        <div class="list-group list-group-escape-container mb-4">
          <router-link
            :to="{ name: 'payment-redirect', params: { id: $route.params.id }, query: getQueryParams(repaymentPartner) }"
            v-for="repaymentPartner of repaymentPartners.filter(x => !x.recommended)"
            class="list-group-item list-group-item-action list-group-item-with-icon"
            v-bind:key="repaymentPartner.id"
          >
            <div>
              <div class="avatar mr-3" :style="'background-image: url(/img/payment/' + repaymentPartner.slug + '.png)'"></div>
            </div>
            <div class="flex-grow-1 mr-2">
              <strong>{{ repaymentPartner.title }}</strong>
              <div class="small text-muted">{{ $t(`PaymentPartners.description.${repaymentPartner.slug}`) }}</div>
            </div>
            <Icon icon-name="arrow-ios-forward-outline" icon-class="text-muted-more"></Icon>
          </router-link>
        </div>
      </div>
      <div class="flex-grow-1"></div><!-- Fill the rest of the page-->

    </div>
  </div>
</template>

<script>

  import Icon from '@shared/components/Icon'
  import ExternalPaymentsMixin from '@/mixins/ExternalPaymentsMixin'
  import TopNav from '@shared/components/TopNav'

  export default {
    name: 'ExternalPaymentsPage',
    components: { TopNav, Icon },
    mixins: [ExternalPaymentsMixin],
    computed: {
      hasRecommended() {
        return this.repaymentPartners.filter(partner => partner.recommended).length > 0
      },
      hasOthers() {
        return this.repaymentPartners.filter(partner => !partner.recommended).length > 0
      },
      hasMoreThanOnePaymentOption() {
        return this.repaymentPartners.length > 1
      }
    },
    methods: {
      getQueryParams(partner) {
        const params = { method: partner.slug }
        if (this.$route.query.amount) {
          params.amount = this.$route.query.amount
        }
        return params
      }
    }
  }
</script>
